import React from 'react';

const SvgFr = (props) => (
  <svg width="1em" height="1em" viewBox="0 -5 28 20" {...props}>
    <defs>
      <rect id="FR_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="#fff" fillRule="evenodd">
      <mask id="FR_svg__b" fill="#fff">
        <use xlinkHref="#FR_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width="1em"
        height="1em"
        rx={2}
      />
      <path fill="#F44653" mask="url(#FR_svg__b)" d="M18.667 0H28v20h-9.333z" />
      <path fill="#1035BB" mask="url(#FR_svg__b)" d="M0 0h9.333v20H0z" />
    </g>
  </svg>
);

export default SvgFr;
